






























import Vue from "vue";

// Import External Components
import FilterContainer from "@miele/component-library-vue/src/components/modules/filter/FilterContainer.vue";
import FilterBox from "@miele/component-library-vue/src/components/modules/filter/FilterBox.vue";
import CheckBoxFilter from "@miele/component-library-vue/src/components/modules/filter/CheckBoxFilter.vue";

export default Vue.extend({
  name: "FilterContainerBox",
  computed: {
    translations() {
      return this.$store.state.translations;
    },
    sortedGroups() {
      return this.$store.getters.getSortedGroups;
    },
    config() {
      return this.$store.state.config;
    },
  },
  components: {
    FilterContainer,
    FilterBox,
    CheckBoxFilter,
  },
  methods: {
    CheckFunction(e: any) {
      const value = {
        name: e.target.name,
        id: e.target.id,
      };

      let tags: any = this.$store.state.searchParams.tags.map(
        (tag: Record<string, any>) => tag
      );

      const tagExists =
        tags.filter((tag: any) => tag.id === e.target.id).length > 0;

      if (tagExists) {
        tags = tags.filter((tag: any) => tag.id !== e.target.id);
      } else {
        tags.push(value);
      }

      this.$store.dispatch("setTags", tags);
    },
    initialContent(group: any) {
      return group.tags.filter(
        (tag: any, index: number) => index < this.config.initialFiltersAmount
      );
    },
    collapsedContent(group: any) {
      return group.tags.filter(
        (tag: any, index: number) => index >= this.config.initialFiltersAmount
      );
    },
    clickFunction(event: any) {
      event.preventDefault();
    },
  },
});
